import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import TableComponent from 'components/atoms/TableComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';

import prehledUzivateluApi, { ISezUzivatelu, IUzivatel } from 'services/spravaUzivatelu/prehled';
import detailUzivateleApi, { IUzivatelDetail } from 'services/spravaUzivatelu/uzivatele';

import Uzivatel from './Uzivatel';

interface IPrehledEmitent {}

const PrehledEmitent: React.FC<IPrehledEmitent> = () => {
    const [zadosti, setZadosti] = useState<ISezUzivatelu>();
    const [errStatus, setErrStatus] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);
    const [offset, setOffset] = useState<number>(0);
    const [selectedUser, setSelectedUser] = useState<IUzivatelDetail>();

    const columns = [
        {
            title: <TranslateText>PRIJMENI</TranslateText>,
            dataIndex: 'prijmeni',
            key: 'prijmeni'
        },
        {
            title: <TranslateText>JMENO</TranslateText>,
            dataIndex: 'jmeno',
            key: 'jmeno'
        },
        {
            title: <TranslateText>TELEFON</TranslateText>,
            dataIndex: 'telefon',
            key: 'telefon'
        },
        {
            title: <TranslateText>EMAIL</TranslateText>,
            dataIndex: 'email',
            key: 'email'
        },
        {
            title: <TranslateText>AUTH_PRVEK</TranslateText>,
            dataIndex: 'typprihlaseni',
            key: 'typprihlaseni',
            render: (typprihlaseni: string) => <TranslateText>{`TYP_PRIHLASENI_${typprihlaseni}`}</TranslateText>
        },
        {
            dataIndex: 'stav',
            key: 'stav',
            width: 200,
            render: (_: IUzivatel, row: IUzivatel, index: number) => (
                <AnchorComponent
                    id={`uzivateleZobrazit${index}Btn`}
                    onClick={() => {
                        setLoading(true);
                        detailUzivateleApi(row.id)
                            .then(data => setSelectedUser(data))
                            .finally(() => setLoading(false));
                    }}
                >
                    <TranslateText>ZOBRAZIT</TranslateText>
                </AnchorComponent>
            )
        }
    ];

    useEffect(() => {
        // nacitanie dat pri zmene strany v table
        if (!selectedUser) {
            setLoading(true);
            setErrStatus(0);
            prehledUzivateluApi(offset)
                .then(resp => {
                    setZadosti(resp);
                })
                .catch((err: any) => {
                    setErrStatus(err.response?.status);
                    setZadosti(undefined);
                })
                .finally(() => setLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offset, selectedUser]);

    return (
        <>
            {errStatus && errStatus !== 404 ? (
                <Row
                    justify="center"
                    align="middle"
                    style={{
                        height: '100%'
                    }}
                >
                    <Col span={16} flex={'0 0 auto'}>
                        <LoadingWrapper loading={loading}>
                            {errStatus ? <Title text="SLUZBA_NEDOSTUPNA" level={3} /> : null}
                        </LoadingWrapper>
                    </Col>
                </Row>
            ) : !selectedUser ? (
                <>
                    <Title level={4} text="PREHLED_UZIVATELU" />
                    <Row gutter={8}>
                        <Col span={24}>
                            <TableComponent
                                loading={loading}
                                columns={columns}
                                rowKey={record => record.id}
                                dataSource={zadosti?.uzivatele}
                                locale={{
                                    emptyText: <TranslateText>ZADNE_UDAJE</TranslateText>
                                }}
                                pagination={{
                                    total: zadosti?.count,
                                    onChange: page => setOffset((page - 1) * 10),
                                    current: offset / 10 + 1,
                                    showSizeChanger: false
                                }}
                            />
                        </Col>
                    </Row>
                </>
            ) : (
                <Uzivatel selectedUser={selectedUser} setSelectedUser={setSelectedUser} prehledData={zadosti} />
            )}
        </>
    );
};

export default PrehledEmitent;
